const Theme = {
  card_max_width: 840,

  logo_image_url: 'mycelium.png',
  header_background_url: 'mycelium.jpg',
  header_padding: 40,
  header_height: 270,
  logo_height: 200,
  token_url: 'mycelium.svg',
  token_width: 69,
  number_hidden: true,

  body_background_color: 'black',

  button_color: '#6fbc85',
  button_radius: 5,
  button_half_border_color: '#6fbc85',

  text_font: `'Arial', sans-serif`,
  text_color: 'black',
  title_font: `'Arial', sans-serif`,
}

export default Theme
